var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L9.795 11.205L12.59 14L14 12.59L8.41 7L14 1.41Z","fill":"#302E2F"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }